import { TextField } from "@mui/material";
import { NumericFormat } from "react-number-format";

type Props = {
  value: number;
  required?: boolean;
  debito?: boolean;
  credito?: boolean;
  setter: React.Dispatch<React.SetStateAction<number>>;
};

const InputCurrency = ({ value, required, setter, debito, credito }: Props) => {
  const debitoOuCredito = (value: number) => {
    if (isNaN(value)) {
      return 0;
    }
    if (debito) {
      if (credito) {
        return value;
      }
      return value <= 0 ? value : value * -1;
    }
    return value >= 0 ? value : value * -1;
  };

  return (
    <NumericFormat
      required={required}
      defaultValue={0}
      value={value}
      onValueChange={(values) => {
        setter(debitoOuCredito(Number(values.floatValue)));
      }}
      customInput={TextField}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      fixedDecimalScale
      valueIsNumericString
      prefix=" R$ "
      variant="standard"
    />
  );
};

export default InputCurrency;
